<div class="toast">
  <span class="toast-icon" [style.color]="iconConfig().color">{{ iconConfig().icon }}</span>
  <span class="toast-message">{{ message() }}</span>
  <button class="toast-close" (click)="closed.emit()">&times;</button>
</div>
